import classNames from 'classnames'
import { forwardRef } from 'react'

import { ensurePropOf } from '../utilities'
import styles from './illustration.module.scss'
import {
  IllustrationComponent,
  IllustrationComponentType,
  IllustrationElement,
  IllustrationProps,
  IllustrationSize,
  IllustrationSizes,
} from './types'

export function wrapIllustration(
  Illustration: React.FunctionComponent<IllustrationProps>,
  priorityProps?: Partial<IllustrationProps>
): IllustrationComponent {
  const BaseIllustration = forwardRef<IllustrationElement, IllustrationProps>(
    function BaseIllustration(props, forwardedRef) {
      const { className, size: sizeProp, ...rest } = props
      const size = ensurePropOf<IllustrationSize>(IllustrationSizes, sizeProp, 'md')
      const classes = classNames(styles[`size${size}`], className)
      return (
        <Illustration
          {...rest}
          className={classes}
          width="100%"
          height="100%"
          focusable={false}
          aria-hidden
          ref={forwardedRef}
          {...priorityProps}
        />
      )
    }
  )
  BaseIllustration.displayName = `${Illustration.name.replace(/^Svg/, '')}Illu`
  ;(BaseIllustration as unknown as IllustrationComponentType).__wrappedIllustration = true
  return BaseIllustration
}
